import type { MealCategoryTranslationEntity } from './MealCategoryTranslationEntity'

export class MealCategoryEntity {
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  id?: number
  iconUrl?: string | null
  enabled?: boolean
  order?: number | null
  isTierFree?: boolean
  translations?: Array<MealCategoryTranslationEntity> | null
}
